import { AnyAction } from 'redux';
import * as UserAccountActionTypes from 'constants/user-account';

export interface UserAccountState {
  trialEligibilityStatus: string;
  isFetching: boolean;
  // error is an opaque value passed straight through from the action
  error: unknown;
}

const initialState: UserAccountState = {
  trialEligibilityStatus: 'eligible',
  isFetching: false,
  error: null,
};

export default function UserAccount(
  state: UserAccountState = initialState,
  action: AnyAction,
): UserAccountState {
  switch (action.type) {
    case UserAccountActionTypes.TRIAL_ELIGIBILITY_STATUS:
      return {
        ...state,
        trialEligibilityStatus: action.trialEligibilityStatus,
      };
    case UserAccountActionTypes.UPDATE_PERSONAL_DATA_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case UserAccountActionTypes.UPDATE_PERSONAL_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
      };
    case UserAccountActionTypes.UPDATE_PERSONAL_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}
